import React from "react";
import { Link } from "react-router-dom";
import LogoProyecto from "../UI/svg/logo-proyecto.svg";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { MAQUETA_ROUTE } from "./../config/routes";

import { ContextLoader } from "./../utils/import.frames";

import {
  initialProyectosWelcome,
  cachedImagesWelcome,
  loadedImagesWelcome,
  stepWelcome,
  loadingWelcome,
  ingresoWelcome,
} from "../redux/actions";

import BienvenidoContainer from "./../container/bienvenidoContainer";

//TODO: Move all caching / preloading logic to another component - controller

class Ingreso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const section = document.querySelector("section");

    this.general = ContextLoader["General View"]();
    this.torre1 = ContextLoader["Torre 1"]();
    this.torre2 = ContextLoader["Torre 2"]();
    this.torre3 = ContextLoader["Torre 3"]();
    this.torre4 = ContextLoader["Torre 4"]();

    console.log(this.torre2)

    this.images = [
        this.general[0],
        this.general[6],
        this.general[12],
        this.general[18],
        this.general[24],
        this.general[30],
        this.general[36],
        this.general[42],
        this.general[48],
        this.general[54],
        this.general[60],
        this.general[66],

        this.torre1[0],
        this.torre1[6],
        this.torre1[12],
        this.torre1[18],
        this.torre1[24],
        this.torre1[30],
        this.torre1[36],
        this.torre1[42],
        this.torre1[48],
        this.torre1[54],
        this.torre1[60],
        this.torre1[66],
    ];

    this.images.forEach((src) => {
      new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;

        /* var stateCopy = Object.assign({}, this.state);
        stateCopy.cache[src] = img;
        this.setState(stateCopy); */

        img.onload = (event) => {
          this.props.loadedImagesWelcome(this.props.loadedImages + 1);
          if (this.props.loadedImages === this.images.length) {
            
            setTimeout(()=>{
              this.props.cachedImagesWelcome(true);
              this.props.loadingWelcome(true);
              this.props.ingresoWelcome(true);
            }, 500)
            
            /* this.handleWelcomeMessage(); */
          }
        };
        img.onerror = (err) => {
          reject();
        };
      }).catch((e) => {
        console.log("[cache error]:", e);
      });
    });

    //LOADING MATERIAL
    this.props.initialProyectosWelcome();
  }

  render() {
    let {
      loaded,
      welcome,
      cachedImages,
      proyecto,
      textures,
      loadedImages,
      step,
      loading
    } = this.props;
    
    return (
      <div
      className={!welcome && !loading ? "loading-page" : "loading-page fixed swap-image"}
    >


      <BienvenidoContainer
        loaded={loaded}
        cachedImages={cachedImages}
        welcome={welcome}
        proyecto={proyecto}
        loadedImages={loadedImages}
        loading={loading}
        constructora={textures["Constructora/logo.jpg"]}
      />

      <div
        className={
          welcome && loading ? "ingreso-container fixed" : "ingreso-container fadeOut"
        }
      >
        <div className="row px-4 pl-2 centered main-container">
          <div className="col-md-12 aling-center logo">
            <img className="logo-proyecto-large" alt="" src={LogoProyecto} />
          </div>
          <div className="text-container">
            <div className="first-text">
            Las imágenes contenidas en este documento, así como el mobiliario, acabados y demás elementos accesorios que aparecen en las mismas, 
            son una representación ilustrativa del Proyecto y no comprometen contractualmente a <strong>BIENES Y BIENES.</strong> En tal virtud, ésta se reserva el derecho de
             realizar cualquier modificación al Proyecto sin previo aviso. Las dimensiones técnicas y estructurales del Proyecto están sujetas a modificaciones.
            </div>
          </div>
          <div className="ingreso">
          {
          welcome ? 
          <Link
              to={{
                pathname: MAQUETA_ROUTE,
                state: {
                  propsProyecto: proyecto,
                  propsTextures: textures,
                },
              }}
              className="btn_ingreso"
            >
              <span>Ingresar</span>
            </Link>
            :
            null
          }
            
          </div>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = ({ welcomeReducer }) => {
  const {
    loaded,
    welcome,
    cachedImages,
    proyecto,
    textures,
    loadedImages,
    step,
    loading
  } = welcomeReducer;
  return {
    loaded,
    welcome,
    cachedImages,
    proyecto,
    textures,
    loadedImages,
    step,
    loading
  };
};
export default withRouter(
  connect(mapStateToProps, {
    initialProyectosWelcome,
    cachedImagesWelcome,
    loadedImagesWelcome,
    stepWelcome,
    loadingWelcome,
    ingresoWelcome
  })(Ingreso)
);
